import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const builtWith = defineConnector({
  identifier: "builtWith",
  name: "BuiltWith",
  tagLine: "Website technology intelligence",
  logo,
  protocol: "http",
  tags: ["data", "security"],
  defaultUrlPattern: () => "https://api\\.builtwith\\.com/.*",
  auth: (app) => queryAuth([{ name: "KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your BuiltWith API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [BuiltWith API portal](https://api.builtwith.com/domain-api). Your API key is shown there, and BuiltWith accepts it as either the `KEY` query parameter or an `Authorization: API` header.",
        },
      ],
    },
    {
      title: "Enter your BuiltWith API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.builtwith.com/v22/api.json?LOOKUP=builtwith.com",
  },
});
